import { ProyectosPlataformaService } from "../../../shared/generated/grpc/plataforma_proyectos_pb";
import { CultivoResponse } from "../../../shared/response/proyectos/CultivoResponse";
import { CultivoPayload } from "../../../shared/services/api/payload/proyectos/CultivoPayload";
import { ServiceSaveBase } from "../../../shared/services/base/ServiceSaveBase";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";
import { CultivoService } from "./CultivoService";

/** Alta y edición de cultivos de proyecto; el resultado reemplaza la fila del listado. */
export class CultivoSaveService extends ServiceSaveBase<CultivoResponse, CultivoPayload> {
  protected readonly cache = CultivoService.instance;

  /** gRPC-Web (`GuardarCultivo`): el slug se deriva del nombre en el servidor. */
  protected async sendSave(p: CultivoPayload): Promise<CultivoResponse> {
    const r = await grpcCall(() => grpcClient(ProyectosPlataformaService).guardarCultivo({
      id: p.id ?? undefined,
      nombre: p.nombre,
      mesesACosecha: p.mesesACosecha,
    }));
    return { id: r.id, isEliminado: false, nombre: r.nombre, slug: r.slug, mesesACosecha: r.mesesACosecha };
  }
}
